import { pushProductAddToCart, pushProductRemoveFromCart, pushCleanEcommerceObject } from "./utils";

const initDataLayerEvents = () => {
    /**
     * Attaches the global event to product being added to cart and does a dataLayer push of this event when it happens.
    */
    document.addEventListener("dataLayer.addToCart", data => {
        const addToCartImpression = data?.detail.dataLayerObject;
        
        pushCleanEcommerceObject();
        pushProductAddToCart(addToCartImpression);
    });

    /**
     * Attaches the global event to product being removed from the cart and does a dataLayer push of this event when it happens.
    */
    document.addEventListener("dataLayer.removeFromCart", function (data) {
        const removeFromCartImpression = data?.detail.dataLayerObject;
        
        pushCleanEcommerceObject();
        pushProductRemoveFromCart(removeFromCartImpression);
    });
};


module.exports = {
    initDataLayerEvents: initDataLayerEvents
};
